import { useState, useEffect } from "react";
import { useAccount } from "wagmi";

const useChainId = () => {
    const [chainId, setChainId] = useState(null);
    const { isConnected, chainId: wagmiChainId } = useAccount();

    useEffect(() => {
        const getChainId = async () => {
            if (window?.ethereum) {
                try {
                    // Attempt to fetch chainId via eth_chainId
                    const chainIdHex = await window.ethereum.request({
                        method: "eth_chainId",
                    });
                    setChainId(Number(chainIdHex));
                } catch (error) {
                    console.error(
                        "eth_chainId not supported, falling back to net_version:",
                        error,
                    );

                    try {
                        // Fallback to net_version if eth_chainId fails
                        const networkId = await window.ethereum.request({
                            method: "net_version",
                        });
                        setChainId(Number(networkId));
                    } catch (fallbackError) {
                        console.error(
                            "Error fetching chainId via net_version:",
                            fallbackError,
                        );
                    }
                }
            }
        };

        if (isConnected) {
            if (wagmiChainId) {
                // Use chainId from wagmi if available
                setChainId(wagmiChainId);
            } else {
                // Fetch chainId directly from the provider
                getChainId();
            }

            // Listen for chain changes
            window?.ethereum?.on("chainChanged", (chainIdHex) => {
                setChainId(Number(chainIdHex));
            });
        } else {
            setChainId(null);
        }

        // Clean up the event listener on unmount
        return () => {
            if (window?.ethereum) {
                window.ethereum.removeListener("chainChanged", (chainIdHex) => {
                    setChainId(Number(chainIdHex));
                });
            }
        };
    }, [isConnected, wagmiChainId]);

    return { chainId };
};

export default useChainId;
